


// todo - remove this file eventually



/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 2/20/13
 * Time: 6:25 PM
 * To change this template use File | Settings | File Templates.
 */
/*
 the configuration file for require.js
 here we define all the AMD modules that are application level modules
 you should define mappings between module names and their paths here
 you should also define shims for modules that aren't AMD defined
 */

/*
 first we need to load all the AMD module configurations defined in each Marionette module
 we will do this using the moduleLoader plugin with the config flag
 */
define(function (require) {
    "use strict";

    var appConfig = require("src/config");
    var uiConfig = require("uiRequireConf");
    // todo - wat?!
    // var moduleConfigs = require("src/moduleLoader!config");
    var moduleConfigs = {};

    var parsedConfig = {
        // 3rd party script alias names (Easier to type "jquery" than "lib/jquery, etc")
        paths : appConfig.paths,
        // Sets the configuration for the third party scripts that are not AMD compatible (using the "use" plugin)
        shim : appConfig.shim
    };

    function extendAppConfig (moduleConfig) {
        // Iterate over the defined paths inside the module and add it
        // to the require global configuration object
        for (var path in moduleConfig.paths) {
            if (path && moduleConfig.paths.hasOwnProperty(path) && !parsedConfig.paths.hasOwnProperty(path) && typeof(moduleConfig.paths[path]) !== 'function') {
                parsedConfig.paths[path] = moduleConfig.paths[path];
            }
        }

        // Iterate over the defined shims inside the module and add it
        // to the require global configuration object
        for (var shim in moduleConfig.shim) {
            if (shim && moduleConfig.shim.hasOwnProperty(shim) && !parsedConfig.shim.hasOwnProperty(shim) && typeof(moduleConfig.shim[shim]) !== 'function') {
                parsedConfig.shim[shim] = moduleConfig.shim[shim];
            }
        }
    }

    var uiModuleConfig = uiConfig(appConfig.paths.uiBasePath);
    extendAppConfig(uiModuleConfig);

    // Iterate over the modules init configurations for loaded modules
    // and add its configurations to the require global configuration object
    for (var module in moduleConfigs) {
        if (module && moduleConfigs.hasOwnProperty(module) && typeof(moduleConfigs[module]) !== 'function') {
            extendAppConfig(moduleConfigs[module]);
        }
    }

    // Set the require configurations
    requirejs.config(parsedConfig);

    return parsedConfig;
});
